module.exports = __webpack_public_path__ + "img/122.872a28de.jpg";